/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { CircularProgress, Paper, Typography, TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'

import FieldIcon from '../components/Fields/FieldIcon'
import FieldDetail from '../components/Fields/FieldDetail'

import Actions from '../../../../fluid/Actions/ActionFactory'

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({
    badge: {
        padding: `0 ${theme.spacing.unit * 0}px`,
    },
    headerStyle : {
        color : '#707070',
        backgroundColor : '#F5F5F5',
        fontSize : 11,
        border : 'none'
    }
})

class FieldSpace extends Component {
    state = {
        statistics : null,
        loading_statistics : false,
        loading_stats_error : false
    }


    componentDidUpdate (prevProps) {
        // let prev_group = prevProps.group_in_focus
        // let current_group = this.props.group_in_focus

        // let prev_field =  prevProps.field_in_focus
        // let current_field = this.props.field_in_focus

        // if (prev_field === null && current_field !== null) {
        //     console.log("IFC :: Setting space(2) state to 'field_detail'")
        //     this.props.update_space_state(2, 'field_detail')
        //     return
        // }

        // if (prev_field !== null && current_field === null) {
        //     console.log("IFC :: Setting space(2) state to null")
        //     this.props.update_space_state(2, null)
        //     return
        // }


        // if (prevProps.field_in_focus === null && this.props.field_in_focus !== null) {
        //     this.props.update_space_state(2, 'field_detail')
        // } else if (prevProps.field_in_focus !== null && this.props.field_in_focus === null) {
        //     this.props.update_space_state(2, null)
        // }
    }

    getBodyHeight = () => {
        let bodyHeight = this.props.space_height - 100
        return bodyHeight
    }

    renderLevel1 = () => {
        return (
            <Paper
                style = {{
                    width : '100%',
                    height  : '50px',
                    display : 'flex',
                    flexDirection : 'row',
                    alignItems : 'center',
                    paddingLeft : '15px'
                }}
                square 
                variant = 'outlined' 
            >
                <Typography style = {{margin : 0, padding : 0}} variant = 'subtitle2' color = 'textPrimary'>{this.props.field_display_name + " Statistics"}</Typography>
            </Paper>
        )
    }

    renderLevel2 = () => {
        return (
            <Paper
                style = {{
                    width : '100%',
                    height  : '50px',
                    display : 'flex',
                    flexDirection : 'row',
                    alignItems : 'center',
                    paddingLeft : '15px'
                }}
                square 
                variant = 'outlined' 
            >
                {this.props.field_in_focus !== null ? 
                <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                    <FieldIcon/>
                    <Typography style = {{marginLeft : '5px'}} variant = 'body2'>{this.props.field_in_focus.field}</Typography>
                </div> : 
                <Typography variant = 'caption' color = 'textSecondary'>Select a field to see it's statistics here.</Typography>}
            </Paper>
        )
    }

    renderStatistics = () => {
        return (
            <FieldDetail
                key = 'fieldspace-field-detail'
                body_height = {this.getBodyHeight() + 50}
                group_display_name = {this.props.group_display_name}
                field_display_name = {this.props.field_display_name}
                ic_name = {this.props.ic_name} 
                version = {this.props.version} 
                report_info = {this.props.report_info}
                global_fields = {this.props.global_fields}
                global_fields_error = {this.props.global_fields_error}
                mapping_global_field = {this.props.mapping_global_field}
                map_global_field = {(entity_id, global_field) => this.props.map_global_field(entity_id, global_field)}
                field_in_focus = {this.props.field_in_focus}
                from = {"All Groups/" + this.props.group_in_focus.group_name}
                field_type = {'field'}
                column_index = {this.props.column_index}
                unfocus_field = {(field_object) => this.props.unfocus_field()}
                checking_field_similarity = {this.props.checking_field_similarity}
                field_similarity_col_indices = {this.props.field_similarity_col_indices}
            />
        )
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{width : '100%', height : '100%', overflow : 'hidden'}}>
                    {this.renderLevel1()}
                    {/* {this.renderLevel2()} */}
                    {this.props.field_in_focus !== null && this.renderStatistics()}
                </div>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(FieldSpace);